export const formatUtcToLocalDateTime = (utcValue) => {
  if (!utcValue) {
    return "-";
  }

  const parsedDate = new Date(utcValue);

  if (Number.isNaN(parsedDate.getTime())) {
    return "-";
  }

  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(parsedDate);
};

export const formatUtcToLocalDate = (value) => {
  if (!value) {
    return "-";
  }

  const parsedDate = new Date(value);

  if (Number.isNaN(parsedDate.getTime())) {
    return "-";
  }

  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
  }).format(parsedDate);
};

/** Format every date picker shows and accepts. */
export const UI_DATE_FORMAT = "MM/DD/YYYY";

/**
 * MM/DD/YYYY, the format date range filters are sent to the API in.
 * Takes a Date, a picker value (YYYY-MM-DD) or an already formatted MM/DD/YYYY string; blank or
 * unparseable input gives ''. YYYY-MM-DD is read as a calendar day, not as UTC midnight, so the
 * day never shifts with the browser's time zone.
 */
export const toApiDate = (value) => {
  if (!value) return "";
  if (typeof value === "string") {
    const text = value.trim();
    const mdy = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (mdy) return `${mdy[1].padStart(2, "0")}/${mdy[2].padStart(2, "0")}/${mdy[3]}`;
    const ymd = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (ymd) return `${ymd[2]}/${ymd[3]}/${ymd[1]}`;
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${mm}/${dd}/${date.getFullYear()}`;
};
